import { render, staticRenderFns } from "./novoCampo.vue?vue&type=template&id=a6630e70&scoped=true"
import script from "./novoCampo.vue?vue&type=script&lang=js"
export * from "./novoCampo.vue?vue&type=script&lang=js"
import style0 from "./novoCampo.vue?vue&type=style&index=0&id=a6630e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6630e70",
  null
  
)

export default component.exports